// Conventions used in values (rendered by <RichText />):
//   "\n"      -> line break
//   [[text]]  -> highlighted span (colour is chosen by the component)
//   __text__  -> italic

const id = {
  meta: {
    title: "P.U.R.B.A. | Pameran Universum Riwayat Bumi Awal – Kebun Raya Bogor",
    description:
      "P.U.R.B.A. adalah pameran perjalanan menyusuri jejak kehidupan purba: dari laut prasejarah, dinosaurus, hingga manusia awal. Segera hadir di Kebun Raya Bogor.",
    imageAlt:
      "Anak penjelajah dengan kaca pembesar di mulut gua purba menghadap gunung api dan dinosaurus, dengan tulisan P.U.R.B.A. Pameran Universum Riwayat Bumi Awal",
    locale: "id_ID",
  },
  // Language-specific image files (artwork with text baked into it)
  images: {
    timeline: "/assets/images/timeline.png",
  },
  alt: {
    partners:
      "Logo mitra: Kebun Raya Bogor, Dyandra Global, dan Life Science Studio",
    aboutImage:
      "Tengkorak dinosaurus berlumut di atas batu, dikelilingi ilustrasi daun dan fosil",
    identityImage:
      "Tengkorak manusia purba pada batuan berlumut di samping siluet manusia purba membawa tombak",
    timeline:
      "40+ spesies purba, 8 zona edutainment, 1 juta tahun cerita bumi",
    logoPurba: "Logo P.U.R.B.A.",
    logoKebunRaya: "Logo Kebun Raya",
    logoDyandra: "Logo Dyandra Global",
    logoLifeScience: "Logo Life Science Studio",
  },
  navbar: {
    subtitle: "PAMERAN UNIVERSUM\nRIWAYAT BUMI AWAL",
    languageLabel: "Pilih bahasa",
  },
  hero: {
    title: "EKSPLORASI\nBARU AKAN\n[[DIMULAI]]",
    subtitle:
      "Sebuah perjalanan menyusuri jejak kehidupan\npurba dari laut prasejarah, dinosaurus,\nhingga manusia awal yang pernah hidup di tanah\nyang sama dengan kita hari ini.",
    comingSoon: "Segera Hadir",
    venue: "Kebun Raya Bogor",
    ticket: "Beli Tiket"
  },
  about: {
    label: "TENTANG PAMERAN",
    title: "Petualangan\nke [[masa lalu]]\nbumi purba!",
    paragraph1:
      "Bayangkan bumi yang kamu pijak jutaan tahun lalu. Belum ada kota. Belum ada jalan. Hanya hutan purba, gunung api aktif, lautan dangkal, dan makhluk-makhluk yang membentuk awal kehidupan.",
    paragraph2:
      "P.U.R.B.A. mengajak pengunjung menjelajahi evolusi bumi melalui fosil, rekonstruksi makhluk purba, dan pengalaman imersif yang menghubungkan sains, sejarah, dan imajinasi.",
  },
  identity: {
    label: "IDENTITAS NUSANTARA",
    title: "CERITA KITA\nDIMULAI [[DI SINI]]!",
    paragraph1:
      "Nusantara menyimpan kisah evolusi yang unik. Dari __Homo floresiensis__ di Flores, jejak manusia purba di Jawa, hingga spesies endemik yang masih bertahan sampai hari ini.",
    paragraph2:
      "Pameran ini menghadirkan perjalanan tentang asal-usul kita bukan hanya sebagai manusia, tetapi juga sebagai bagian dari bumi yang terus berubah.",
  },
  visit: {
    label: "RENCANAKAN KUNJUNGANMU",
    title: "Temui Kami\nDi Kebun Raya\nBogor",
    description:
      "P.U.R.B.A. hadir di Gedung Melchior, Kebun Raya Bogor di tengah ruang hijau yang telah menjadi saksi perjalanan ilmu pengetahuan dan sejarah Indonesia.",
    address:
      "Gedung Melchior\nJl. Ir. H. Juanda No. 13\nBogor Tengah, Kota Bogor\nJawa Barat 16122",
    hours:
      "Jam Buka\nSEGERA HADIR!\nJadwal detail akan\ndiumumkan via instagram",
    audience:
      "Untuk Semua\nPelajar, keluarga,\ndan pencinta sains\nselamat datang!",
    mapTitle: "Peta lokasi di Google Maps",
  },
  footer: {
    helpTitle: "Butuh bantuan?\nKami siap membantu",
    helpText: "Hubungi kami melalui salah\nsatu saluran di bawah ini.",
    hotline: "Hotline:",
    email: "Email:",
    connect: "Terhubung dengan kami",
    handle: "Riwayat\nPurba",
  },
  comingSoon: {
    title: "SEGERA [[HADIR]]",
    description:
      "Konten pembelajaran untuk item ini sedang kami siapkan. Nantikan kehadirannya!",
  },
};

export default id;
